<!--  -->
<template>
    <div class="details">
        <header>
            <div 
                class="wrap_header"
            >
                <h1>
                    <img 
                        src="./Register/images/lhv2DA.png"
                    >
                </h1>
                <div>
                    <router-link to="/login">
                        登录
                    </router-link>
                    <router-link :to="{name:'register',query:{_q:cookieStr}}">
                        免费注册
                    </router-link>
                </div>
            </div>
        </header>
        <img 
            v-if="isFlag"
            src="./Register/images/ETCLD.jpg" 
            class="images_wrap"
        >
        <v-goTop />
    </div>
</template>

<script>
import GoTop from "@/components/nf-top/index";
import { getCookie } from '@/utils/index'
export default {
    components:{
        'v-goTop': GoTop
    },
    data () {
        return {
            cookieStr:''
        }
    },
    computed:{
        isFlag(){
            return this.$store.state.isFlag
        }
    },
    created(){
        this.cookieStr=getCookie('_q')
    }
}

</script>

<style lang='scss' scoped>
    header {
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 0;
        left: 0;
        height: 50px;
        z-index: 2;
        background:rgba(255,255,255,1);
        .wrap_header{
            margin: 0 auto;
            width: 1200px;
            display: flex;
            justify-content: space-between;
            img{
                padding: 11px 0;
                width:90px;
                height:32px;
            }
            div{
                a{
                    line-height: 50px;
                    cursor: pointer;
                    font-size: 14px;
                }
                a:first-child{
                    color: #333;
                }
                a:first-child:hover{
                    color:rgb(241, 72, 5) ;
                }
                a:last-child{
                    margin-left: 30px;
                    background: rgb(241, 72, 5);
                    color: aliceblue;
                    padding: 8px 22px;
                    
                }
                a:last-child:hover{
                    background: rgba(241, 72, 5,.8);
                }
            }
        }
    }
</style>
